export const addClassesFromProps = (classes?: string) => {
  return classes ? ` ${classes}` : '';
};

export function trim(val: string) {
  if (!val || val.trim() === '') return '';
  return val;
}
